<template>
    <v-dialog :value="value" @input="(val) => { $emit('input', val) }" max-width="1200">
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">
                    Gegevens
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="2">
                    Exporteren
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1" class="eod-export-dialog__content">
                    <div class="px-2 py-2">
                        <v-select data-testid="export-module" v-model="selectedModule" @change="moduleChanged" return-object :items="modules" dense
                            outlined item-value="unique" item-text="endpoint" label="Wat wilt u exporteren?">
                            <template v-slot:selection="data">
                                <div class="d-flex align-center">
                                    <v-icon left v-html="data.item.icon"></v-icon>
                                    <span>{{ $t(data.item.unique) }}</span>
                                </div>
                            </template>
                            <template v-slot:item="data">
                                <v-list dense class="py-0">
                                    <v-list-item class="px-0">
                                        <v-list-item-icon class="mr-2">
                                            <v-icon v-html="data.item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t(data.item.unique) }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </template>
                        </v-select>
                        <div>
                            <v-row class="align-items-center mb-2">
                                <v-col>
                                    <eod-search topbar flat
                                        v-if="exportSearchConfig"
                                        v-model="selectedFilters" :config="exportSearchConfig"
                                        @update="renderPreview"></eod-search>
                                    <eod-search topbar flat
                                        v-if="selectedModule && selectedModule.value && customSearchConfig"
                                        v-model="selectedFilters" :config="customSearchConfig"
                                        @update="renderCustomPreview"></eod-search>
                                </v-col>
                                <v-col v-if="selectedModule && selectedModule.hasTimeSelector" cols="auto">
                                    <eod-time-selector v-model="selectedTimeFilter"
                                        :fields="exportTimeFields" :field="timeFilterField" @update:field="timeFilterField = $event"
                                        @input="selectedModule.model ? renderPreview() : renderCustomPreview()"></eod-time-selector>
                                </v-col>
                                <v-col v-if="(selectedModule && selectedModule.hasLanguageSelector) || hasLanguageSelector" cols="auto">
                                    <v-select data-testid="export-language" prepend-inner-icon="mdi-translate" style="width:160px;" hide-details rounded dense outlined :items="[{text:'NL', value:'nl'},{text:'EN', value:'en'},{text:'FR', value:'fr'}]" v-model="selectedLanguage"></v-select>
                                </v-col>
                                <v-col v-if="selectedModule && selectedModule.customFields" cols="auto">
                                    <v-checkbox class="mt-0 mb-0" @change="selectedModule.model ? renderPreview() : renderCustomPreview()" hide-details v-model="appendCustomFields" label="Inclusief aangepaste velden"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-progress-linear v-if="previewLoading" indeterminate></v-progress-linear>
                        </div>
                    </div>

                    <div class="py-2" style="overflow-y: auto;flex-grow: 1;" v-if="!previewLoading">
                                <v-data-table
                                    
                                    :items-per-page="-1" :hide-default-footer="true" fixed-header dense
                                    :items="previewItems" :headers="previewHeaders"></v-data-table>
                            </div>
                            <template v-if="!previewLoading">
                                <v-alert dense class="mb-1" type="info" text v-if="(previewItemsTotal > previewItems.length)">Enkel
                                    de
                                    eerste {{ previewItems.length }} rijen van de {{ previewItemsTotal }} worden
                                    weergegeven.</v-alert>
                                <v-alert dense class="mb-1" type="info" text v-if="(previewItemsTotal > 1500)">Enkel de eerste
                                    1500
                                    rijen worden geëxporteerd!</v-alert>
                            </template>
                    <v-divider></v-divider>
                    <div class="px-2 py-2 d-flex">
                        <v-btn text @click="$emit('input', false)">Annuleren</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn data-testid="export-next" color="primary" @click="exportItems">
                            Volgende
                        </v-btn>
                    </div>
                </v-stepper-content>

                <v-stepper-content step="2" class="eod-export-dialog__content">
                    <div class="px-2 py-2 mb-4">
                        <template v-if="exportLoading">
                            <h2>Genereren</h2>
                            <p>Bezig met genereren...</p>
                        </template>
                        <template v-else-if="!exportError">
                            <h2>Klaar</h2>
                            <p>Exporteren gelukt!</p>
                        </template>
                        <template v-else>
                            <h2>Fout</h2>
                            <v-alert type="error" text>
                                Het exporteren van de gegevens heeft mogelijks te lang geduurd. Gelieve de filter te verfijnen en opnieuw te proberen.
                            </v-alert>
                        </template>

                    </div>

                    <v-divider class="mt-auto"></v-divider>
                    <div class="px-2 py-2 d-flex">
                        <v-btn text @click="$emit('input', false)">
                            Sluiten
                        </v-btn>
                        <v-spacer></v-spacer>

                        <v-btn data-testid="export-download" v-if="!exportError" :loading="exportLoading" :href="downloadUrl" color="primary"><v-icon
                                left>mdi-microsoft-excel</v-icon>Downloaden</v-btn>
                    </div>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
</template>
<style lang="scss">
.eod-export-dialog__content {
    .v-stepper__wrapper {
        height: calc(100vh - 160px);
        max-height: 600px;
        display: flex;
        flex-direction: column;
        //overflow-y: auto;
    }

}
</style>
<script>
import eodSearch from './eod-search';
import eodTimeSelector from './eod-time-selector';
import _ from 'lodash';

export default {
    name: 'eod-export-dialog',
    components: {
        eodSearch,
        eodTimeSelector,
    },
    props: {
        value: Boolean,
        filters: Array,
        timeFilters: Object,
        endpoint: String
    },
    data: () => ({
        // General
        step: 1,
        fieldMapping: {},

        // 1. Data
        settings: require('../classes/settings'),
        modules: [],
        selectedModule: null,
        selectedFilters: [],
        appendCustomFields: true,

        // 2. Preview
        previewLoading: false,
        previewItems: [],
        previewItemsTotal: 0,
        previewHeaders: [],
        customSearchConfig: null,
        selectedTimeFilter: null,
        hasLanguageSelector: false,
        selectedLanguage: 'nl',
        timeFilterField: 'createdAt',

        // Export
        exportLoading: false,
        exportError: null,
        downloadUrl: null,

    }),
    async created() {
        const fieldMappingSetting = this.$eod.getOrganizationSetting('organization.exports.fieldMapping');
        if(fieldMappingSetting && fieldMappingSetting.value){
            this.fieldMapping = JSON.parse(fieldMappingSetting.value);
        }

        const customExportSetting = this.$eod.getOrganizationSetting('organization.exports.custom.listId');
        if (customExportSetting && customExportSetting.value) {
            const listItems = await this.$eod.getById('list', customExportSetting.value, ['id', 'name', 'description', 'isActive', 'itemType', 'fields{name isActive}', 'listItems{id name description isActive low high stepSize threshold fields{name isActive}}'])
                .then(response => {
                    if (response.data.data.list) {
                        return response.data.data.list.listItems;
                    }

                    return null;
                });

            if (listItems && listItems.length > 0) {
                this.modules.push({ header: 'Op maat' });
                for (let i = 0; i < listItems.length; i++) {
                    const listItem = listItems[i];
                    this.modules.push({
                        unique: listItem.name,
                        icon: 'mdi-table',
                        value: listItem.fields[0] ? listItem.fields[0].name : null,
                        module_link: listItem.fields[1] ? listItem.fields[1].name : null
                    });
                }
            }
        }

        if (this.settings && this.settings.modules) {
            this.modules.push({ header: 'Modules' });
            for (const moduleName in this.settings.modules) {
                const moduleInfo = this.settings.modules[moduleName];

                if (moduleInfo.model && moduleInfo.model.searchConfig && moduleInfo.model.exportFields) {
                    this.modules.push({
                        unique: moduleName,
                        ...moduleInfo
                    });
                }
            }
        }

        if (this.endpoint) {
            for (let i = 0; i < this.modules.length; i++) {
                const mod = this.modules[i];
                if (mod.unique == this.endpoint) {
                    this.selectedModule = mod;
                    break;
                }
            }
        }

        if (this.filters) {
            const filters = _.cloneDeep(this.filters);
            if(this.selectedModule && this.selectedModule.model && this.selectedModule.model.exportSearchConvert){
                this.selectedFilters = this.convertExportFilter(this.selectedModule.model, filters);
            } else {
                this.selectedFilters = filters;
            }
            
        }

        if (this.timeFilters) {
            this.selectedTimeFilter = this.timeFilters;
            // Neem het datumveld over dat in de lijst gekozen werd.
            if (this.timeFilters.field) {
                this.timeFilterField = this.timeFilters.field;
            }
        }

        if(this.selectedModule){
            this.renderPreview();
        }

    },
    computed: {
        exportSearchConfig() {
            if (!this.selectedModule || !this.selectedModule.model) {
                return null;
            }
            const cfg = this.selectedModule.model.exportSearchConfig || this.selectedModule.model.searchConfig;
            if (!cfg) {
                return null;
            }
            // Datumvelden zitten nu in de tijd-widget (rechts), niet meer in de inhoudelijke filter.
            return cfg.filter(c => c.type !== 'date-between');
        },
        exportTimeFields() {
            // Alle datumvelden van de module worden tijdsfilters (in de tijd-widget),
            // afgeleid uit de date-between-filters van de searchConfig. Valt terug op
            // de basisvelden (aanmaak/aanpassing) als er geen zijn.
            const base = require('../classes/timeFields').baseTimeFields;
            if (!this.selectedModule || !this.selectedModule.model) {
                return base;
            }
            const cfg = this.selectedModule.model.exportSearchConfig || this.selectedModule.model.searchConfig;
            const dateFields = (cfg || [])
                .filter(c => c.type === 'date-between')
                .map(c => ({ value: c.filter, label: c.label }));
            return dateFields.length ? dateFields : base;
        },
    },
    methods: {
        convertExportFilter(model, filters){
            const convert = model.exportSearchConvert;
            const exportFilters = [];
            if(filters){
                for (let i = 0; i < filters.length; i++) {
                    const filter = filters[i];
                    if(convert.hasOwnProperty(filter.config.filter)){
                        if(convert[filter.config.filter]){
                            if(model.exportSearchConfig){
                                for (let j = 0; j < model.exportSearchConfig.length; j++) {
                                    const exportConfig = model.exportSearchConfig[j];
                                    if(exportConfig.filter == convert[filter.config.filter]){
                                        filter.config = exportConfig;
                                        break;
                                    }
                                }
                            } else {
                                filter.config.filter = convert[filter.config.filter];
                            }
                            
                            exportFilters.push(filter);
                        }
                    } else {
                        exportFilters.push(filter);
                    }
                }
            }

            return exportFilters;
        },
        moduleChanged(item) {
            this.selectedFilters = [];
            this.customSearchConfig = null;
            this.hasLanguageSelector = false;
            // Standaard-datumveld = eerste beschikbare tijdsveld van de gekozen module.
            const fields = this.exportTimeFields;
            this.timeFilterField = (fields && fields[0]) ? fields[0].value : 'createdAt';

            if (item.model) {
                this.renderPreview();
            } else if (item.value) {
                this.getCustomSearchConfig().then(() => {
                    this.renderCustomPreview();
                });
                
            }
        },
        getHeadersOfField(field) {
            let allFields = [];
            if (field.includes('{')) {
                field = field.replaceAll('}', '');
                field = field.replaceAll('{', ' ');
                const fields = field.split(/[\s,]+/);
                for (let i = 1; i < fields.length; i++) {
                    const splitField = fields[i];
                    allFields.push(fields[0] + '.' + splitField);
                }
            } else {
                allFields.push(field);
            }

            return allFields;
        },
        getVariables() {
            let variables = this.$helper.filtersToVariables(this.selectedFilters);
            if (this.selectedModule.model && this.selectedModule.model.exportFilters) {
                const moduleFilters = _.clone(this.selectedModule.model.exportFilters);
                for (const filterName in moduleFilters) {
                    const filters = moduleFilters[filterName];
                    if(typeof filters == 'object'){
                        if(!variables[filterName]){
                            variables[filterName] = [];
                        }
                        variables[filterName].push(...filters);
                    } else if(!variables[filterName]) {
                        variables[filterName] = filters;
                    }
                }
            }

            if (this.selectedModule.hasTimeSelector && this.selectedTimeFilter) {
                if (!variables.where) {
                    variables.where = [];
                }

                variables.where.push({
                    column: this.timeFilterField,
                    operator: '>=',
                    value: this.selectedTimeFilter.from.toISOString()
                });
                variables.where.push({
                    column: this.timeFilterField,
                    operator: '<=',
                    value: this.selectedTimeFilter.until.toISOString()
                });
            }

            return variables;
        },
        getCustomSearchConfig() {
            this.customSearchConfig = null;
            return this.$eod.exportCustomSearchConfig(this.selectedModule.value).then(response => {
                if (response.data) {
                    this.customSearchConfig = response.data.searchConfig;
                    if (response.data.timeSelector) {
                        this.timeFilterField = response.data.timeSelector.filter;
                    }
                    if(response.data.languageSelector) {
                        this.hasLanguageSelector = response.data.languageSelector;
                    }
                }
            });
        },
        renderCustomPreview() {
            this.previewHeaders = [];
            this.previewLoading = true;
            let variables = this.getVariables();
            variables.language = this.selectedLanguage;
            variables.limit = 10;

            this.$eod.exportCustomPreview(this.selectedModule.value, variables).then(response => {
                let headers = [];
                let items = [];
                let totalCount = 0;
                if(response && response.data && response.data.result){
                    headers = Object.keys(response.data.result[0]);
                    items = response.data.result;
                    totalCount = response.data.total;
                } else if (response && response.data && response.data[0]) {
                    headers = Object.keys(response.data[0]);
                    items = response.data;
                    totalCount = response.data.length;
                }

                for (let j = 0; j < headers.length; j++) {
                        const header = headers[j];
                        this.previewHeaders.push({
                            value: header,
                            text: header,
                            //width: '250px',
                            sortable: false,
                        });
                    }

                this.previewItems = items;
                this.previewItemsTotal = totalCount;
            }).finally(() => {
                this.previewLoading = false;
            });
        },
        mapExportFields(field){
            if(this.fieldMapping && this.fieldMapping[this.selectedModule.endpoint] && this.fieldMapping[this.selectedModule.endpoint][field]){
                return this.fieldMapping[this.selectedModule.endpoint][field];
            } else if (this.fieldMapping && this.fieldMapping.global && this.fieldMapping.global[field]){
                return this.fieldMapping.global[field];
            }

            return field;
        },
        async renderPreview() {
            this.previewHeaders = [];
            this.previewLoading = true;

            const exportFields = [];
            const moduleCustomFields = [];

            if(this.appendCustomFields && this.selectedModule.customFields){
                await this.$eod.get('customFields', ['id', 'name','type', 'module', 'items'], {
                    where: [
                        {
                            column: 'module',
                            value: this.selectedModule.customFields.endpoint
                        }
                    ]
                })
                    .then(response => {
                        moduleCustomFields.push(...response.data.data.customFields.edges);
                    });

                if(this.selectedModule.customFields.extraFields){
                    await this.$eod.get('customFields', ['id', 'name', 'type', 'module', 'items'], {
                        where: [
                            {
                                column: 'isChildField',
                                value: '1'
                            }
                        ],
                        whereIn:[
                            {
                                column: 'module',
                                array: this.selectedModule.customFields.extraFields
                            }
                        ]
                    })
                    .then(response => {
                        moduleCustomFields.push(...response.data.data.customFields.edges);
                    });
                }                
            }

            for (let i = 0; i < this.selectedModule.model.exportFields.length; i++) {
                const field = this.selectedModule.model.exportFields[i];
                const headers = this.getHeadersOfField(field);

                exportFields.push(field);

                for (let j = 0; j < headers.length; j++) {
                    const header = headers[j];
                    this.previewHeaders.push({
                        value: header,
                        text: this.mapExportFields(header.replaceAll('.', '__')),
                        width: '250px',
                        sortable: false,
                    });
                }
            }

            let variables = this.getVariables();

            if(this.appendCustomFields && this.selectedModule.customFields){

                // Resolve custom field items
                const customFieldItemIds = {};
                for (let j = 0; j < moduleCustomFields.length; j++) {
                    const moduleCustomField = moduleCustomFields[j];
                    if(moduleCustomField.items && moduleCustomField.items[0]){
                        if(!customFieldItemIds[moduleCustomField.module]){
                            customFieldItemIds[moduleCustomField.module] = [];
                        }
                        customFieldItemIds[moduleCustomField.module].push(...moduleCustomField.items);
                    }
                }

                const customFieldsItemsResolved = {};
                for (const moduleName in customFieldItemIds) {
                    const ids = customFieldItemIds[moduleName];

                    if(ids[0]){
                        customFieldsItemsResolved[moduleName] = await this.$eod.get(moduleName, ['id','name'], {
                            whereIn:[
                                {
                                    column: 'id',
                                    array: ids
                                }
                            ]
                        }).then(response => {
                            const resolved = {};
                            for (let itemIndex = 0; itemIndex < response.data.data[moduleName].edges.length; itemIndex++) {
                                const resolvedItem = response.data.data[moduleName].edges[itemIndex];
                                resolved[resolvedItem.id] = resolvedItem;
                            }
                            return resolved;
                        })
                    }
                }

                for (let j = 0; j < moduleCustomFields.length; j++) {
                    const customField = moduleCustomFields[j];

                    let name = customField.name;

                    const resolved = [];
                    if(customField.items && customField.items[0]){
                        for (let itemIndex = 0; itemIndex < customField.items.length; itemIndex++) {
                            const itemId = customField.items[itemIndex];
                            if(customFieldsItemsResolved[customField.module][itemId]){
                                resolved.push(customFieldsItemsResolved[customField.module][itemId].name);
                            }
                        }
                    }

                    if(resolved[0]){
                        resolved.sort();

                        name += ' ('+resolved.join(', ')+')';
                    }

                    this.previewHeaders.push({
                        value: 'customfield_' + customField.id,
                        text: name,
                        width: '250px',
                        sortable: false,
                    });
                }
                exportFields.push('customFields{customFieldId value}');
            }

            variables.limit = 10;
            variables.offset = 0;

            this.$eod.get(this.selectedModule.endpoint, exportFields, variables)
                .then(async response => {
                    if (response.data.data && response.data.data[this.selectedModule.endpoint] && response.data.data[this.selectedModule.endpoint].edges) {
                        const items = response.data.data[this.selectedModule.endpoint].edges;
                        const listItemsToResolve = [];
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if(item.customFields){
                                for (let j = 0; j < item.customFields.length; j++) {
                                    const field = item.customFields[j];
                                    const customField = this.$helper.getArrayItemByProperty(moduleCustomFields, 'id', field.customFieldId);
                                    if(customField && ['labels', 'list'].includes(customField.type) && !listItemsToResolve.includes(field.value)){
                                        listItemsToResolve.push(field.value);
                                    }
                                }
                            }
                        }

                        const resolvedListItems = {};
                        if(listItemsToResolve[0]){
                            await this.$eod.get('listItems', ['id','name'], {
                                whereIn: [
                                    {
                                        column: 'id',
                                        array: listItemsToResolve
                                    }
                                ]
                            }).then(response => {
                                for (let i = 0; i < response.data.data.listItems.edges.length; i++) {
                                    const listItem = response.data.data.listItems.edges[i];
                                    resolvedListItems[listItem.id] = listItem;
                                }
                            });
                        }

                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            for (let j = 0; j < moduleCustomFields.length; j++) {
                                const customField = moduleCustomFields[j];
                                if(item.customFields){
                                    const fieldVal = this.$helper.getArrayItemByProperty(item.customFields, 'customFieldId', customField.id);
                                    if(fieldVal && ['labels','list'].includes(customField.type)){
                                        fieldVal.value = resolvedListItems[fieldVal.value]?resolvedListItems[fieldVal.value].name:null;
                                    }
                                    items[i]['customfield_'+customField.id] = fieldVal?fieldVal.value:null;
                                }
                            }

                            if(items[i].customFields){
                                delete items[i].customFields;
                            }
                        }
                        this.previewItems = items;
                        this.previewItemsTotal = response.data.data[this.selectedModule.endpoint].totalCount;
                        //this.step = 2;
                    } else {
                        console.error('error getting preview');
                    }
                }).catch(() => {
                    console.error('error getting preview');
                }).finally(() => {
                    this.previewLoading = false;
                });
        },
        exportItems() {
            this.exportLoading = true;
            this.step = 2;

            const settings = {...this.selectedModule};
            if(!this.appendCustomFields){
                delete settings.customFields;
            }

            let exportAction = null;
            let variables = this.getVariables();
            if (this.selectedModule.model) {
                exportAction = this.$eod.export(this.selectedModule.endpoint, this.selectedModule.model.exportFields, variables, settings);
            } else {
                exportAction = this.$eod.exportCustom(this.selectedModule.value, variables, {
                    language: this.selectedLanguage
                });
            }

            exportAction.then(response => {
                if (response.data.success) {
                    this.downloadUrl = response.data.path;
                } else {
                    this.exportError = response.data.error;
                }
            }).catch((e) => {
                this.exportError = e;
            }).finally(() => {
                this.exportLoading = false;
            });

        }
    }
}
</script>